import { boxGripEnum, nextgenScreenMode } from '../../constants';
import { getOutlineRect, getRectPoints, getRotateResult, rotateElement } from '../../../canvas/logics';

import { elementType } from '../../../utils/constants';
import { getRotatedPointByGripPosition } from '../../canvas/ImageCrop/logics';
import { getScreenMode } from '../../logics';
import { isOnFoldLine } from '../../../elements/utils';

export const calculateResizeRatio = (pos, p1, p2) => {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const len2 = dx * dx + dy * dy;
  const dot = (pos.x - p1.x) * dx + (pos.y - p1.y) * dy;
  return dot / len2;
};

export const getResizeRatio = (pos, rotatedRectPoints, gripIndex) => {
  const { p1, p2 } = getVectorByGripPosition(gripIndex, rotatedRectPoints);
  return calculateResizeRatio(pos, p1, p2);
};

export const resizeElementFunc = (gripIndex, noRotateRect, resizeRatio, rotatedRectPoints, degree, elementData) => {
  const newRotatedRectPoints = adjustRotatedRectPoints(rotatedRectPoints, gripIndex, resizeRatio);

  //const resizedNoRotateRect = getResizedNoRotateRect(gripIndex, noRotateRect, resizeRatio);

  const newOutlineRect = getOutlineRect(newRotatedRectPoints);
  const derivedRects = getDerivedRects(newRotatedRectPoints, degree);

  return {
    outlineRect: newOutlineRect,
    rotatedRectPoints: newRotatedRectPoints,
    derivedRects,
    // resizedNoRotateRect,
  };
};

export const adjustRotatedRectPoints = (rotatedRectPoints, gripIndex, resizeRatio) => {
  const newRotatedRectPoints = [];
  if (gripIndex === boxGripEnum.BottomRight) {
    newRotatedRectPoints[0] = rotatedRectPoints[0];
    newRotatedRectPoints[1] = getPointByRatio(rotatedRectPoints[0], rotatedRectPoints[1], resizeRatio);
    newRotatedRectPoints[2] = getPointByRatio(rotatedRectPoints[0], rotatedRectPoints[2], resizeRatio);
    newRotatedRectPoints[3] = getPointByRatio(rotatedRectPoints[0], rotatedRectPoints[3], resizeRatio);
  } else if (gripIndex === boxGripEnum.TopLeft) {
    newRotatedRectPoints[2] = rotatedRectPoints[2];
    newRotatedRectPoints[0] = getPointByRatio(rotatedRectPoints[2], rotatedRectPoints[0], resizeRatio);
    newRotatedRectPoints[1] = getPointByRatio(rotatedRectPoints[2], rotatedRectPoints[1], resizeRatio);
    newRotatedRectPoints[3] = getPointByRatio(rotatedRectPoints[2], rotatedRectPoints[3], resizeRatio);
  } else if (gripIndex === boxGripEnum.BottomLeft) {
    newRotatedRectPoints[1] = rotatedRectPoints[1];
    newRotatedRectPoints[0] = getPointByRatio(rotatedRectPoints[1], rotatedRectPoints[0], resizeRatio);
    newRotatedRectPoints[2] = getPointByRatio(rotatedRectPoints[1], rotatedRectPoints[2], resizeRatio);
    newRotatedRectPoints[3] = getPointByRatio(rotatedRectPoints[1], rotatedRectPoints[3], resizeRatio);
  } else if (gripIndex === boxGripEnum.TopRight) {
    newRotatedRectPoints[3] = rotatedRectPoints[3];
    newRotatedRectPoints[0] = getPointByRatio(rotatedRectPoints[3], rotatedRectPoints[0], resizeRatio);
    newRotatedRectPoints[1] = getPointByRatio(rotatedRectPoints[3], rotatedRectPoints[1], resizeRatio);
    newRotatedRectPoints[2] = getPointByRatio(rotatedRectPoints[3], rotatedRectPoints[2], resizeRatio);
  } else if (gripIndex === boxGripEnum.TopMiddle) {
    newRotatedRectPoints[2] = rotatedRectPoints[2];
    newRotatedRectPoints[3] = rotatedRectPoints[3];
    newRotatedRectPoints[0] = getPointByRatio(rotatedRectPoints[3], rotatedRectPoints[0], resizeRatio);
    newRotatedRectPoints[1] = getPointByRatio(rotatedRectPoints[2], rotatedRectPoints[1], resizeRatio);
  } else if (gripIndex === boxGripEnum.RightMiddle) {
    newRotatedRectPoints[0] = rotatedRectPoints[0];
    newRotatedRectPoints[3] = rotatedRectPoints[3];
    newRotatedRectPoints[1] = getPointByRatio(rotatedRectPoints[0], rotatedRectPoints[1], resizeRatio);
    newRotatedRectPoints[2] = getPointByRatio(rotatedRectPoints[3], rotatedRectPoints[2], resizeRatio);
  } else if (gripIndex === boxGripEnum.BottomMiddle) {
    newRotatedRectPoints[0] = rotatedRectPoints[0];
    newRotatedRectPoints[1] = rotatedRectPoints[1];
    newRotatedRectPoints[2] = getPointByRatio(rotatedRectPoints[1], rotatedRectPoints[2], resizeRatio);
    newRotatedRectPoints[3] = getPointByRatio(rotatedRectPoints[0], rotatedRectPoints[3], resizeRatio);
  } else if (gripIndex === boxGripEnum.LeftMiddle) {
    newRotatedRectPoints[1] = rotatedRectPoints[1];
    newRotatedRectPoints[2] = rotatedRectPoints[2];
    newRotatedRectPoints[0] = getPointByRatio(rotatedRectPoints[1], rotatedRectPoints[0], resizeRatio);
    newRotatedRectPoints[3] = getPointByRatio(rotatedRectPoints[2], rotatedRectPoints[3], resizeRatio);
  }
  return newRotatedRectPoints;
};

export const getPointByRatio = (p1, p2, ratio) => {
  const x = p1.x + ratio * (p2.x - p1.x);
  const y = p1.y + ratio * (p2.y - p1.y);
  return { x, y };
};

export const getDerivedRects = (rotatedRectPoints, degree) => {
  const newNoRotateRect = getRotateResult(rotatedRectPoints, degree).outlineRect;
  return { newNoRotateRect };
};

export const getDerivedRectsForCrop = (rotatedRectPoints, baseImageRect, degree) => {
  const noRotateRectInPosition = rotateElement(rotatedRectPoints, degree).outlineRect;
  return { noRotateRectInPosition, newNoRotateRect: noRotateRectInPosition, newBaseImageRect: baseImageRect };
};

export const getResizedNoRotateRect = (gripIndex, noRotateRect, resizeRatio) => {
  const rectPoints = getRectPoints(noRotateRect);
  let ratio = resizeRatio / 2;
  let p1, p2;
  let newWidth, newHeight;
  if (
    gripIndex === boxGripEnum.TopLeft ||
    gripIndex === boxGripEnum.BottomRight ||
    gripIndex === boxGripEnum.TopRight ||
    gripIndex === boxGripEnum.BottomLeft
  ) {
    const result = getVectorByGripPosition(gripIndex, rectPoints);
    p1 = result.p1;
    p2 = result.p2;
    newWidth = noRotateRect.width * resizeRatio;
    newHeight = noRotateRect.height * resizeRatio;
  } else if (gripIndex === boxGripEnum.TopMiddle || gripIndex === boxGripEnum.BottomMiddle) {
    const tm = getRotatedPointByGripPosition(boxGripEnum.TopMiddle, rectPoints);
    const bm = getRotatedPointByGripPosition(boxGripEnum.BottomMiddle, rectPoints);
    p1 = gripIndex === boxGripEnum.TopMiddle ? bm : tm;
    p2 = gripIndex === boxGripEnum.TopMiddle ? tm : bm;
    newWidth = noRotateRect.width;
    newHeight = noRotateRect.height * resizeRatio;
  } else {
    const rm = getRotatedPointByGripPosition(boxGripEnum.RightMiddle, rectPoints);
    const lm = getRotatedPointByGripPosition(boxGripEnum.LeftMiddle, rectPoints);
    p1 = gripIndex === boxGripEnum.RightMiddle ? lm : rm;
    p2 = gripIndex === boxGripEnum.RightMiddle ? rm : lm;
    newWidth = noRotateRect.width * resizeRatio;
    newHeight = noRotateRect.height;
  }

  const newCenter = getPointByRatio(p1, p2, ratio);

  const resizedNoRotateRect = {
    x: newCenter.x - newWidth / 2,
    y: newCenter.y - newHeight / 2,
    width: newWidth,
    height: newHeight,
  };

  return resizedNoRotateRect;
};

export const getVectorByGripPosition = (gripIndex, rotatedRectPoints) => {
  const indexes =
    gripIndex === boxGripEnum.TopLeft
      ? [2, 0]
      : gripIndex === boxGripEnum.BottomRight
      ? [0, 2]
      : gripIndex === boxGripEnum.TopRight
      ? [3, 1]
      : gripIndex === boxGripEnum.BottomLeft
      ? [1, 3]
      : gripIndex === boxGripEnum.TopMiddle
      ? [3, 0]
      : gripIndex === boxGripEnum.RightMiddle
      ? [0, 1]
      : gripIndex === boxGripEnum.BottomMiddle
      ? [0, 3]
      : gripIndex === boxGripEnum.LeftMiddle
      ? [1, 0]
      : [0, 2];
  const p1 = rotatedRectPoints[indexes[0]];
  const p2 = rotatedRectPoints[indexes[1]];
  return { p1, p2 };
};

export const getRectCenter = (rect) => {
  const x = rect.x + rect.width / 2;
  const y = rect.y + rect.height / 2;
  return { x, y };
};

export const getRectPointsCenter = (rotatedRectPoints) => {
  const x = (rotatedRectPoints[0].x + rotatedRectPoints[2].x) / 2;
  const y = (rotatedRectPoints[0].y + rotatedRectPoints[2].y) / 2;
  return { x, y };
};

export const isImageInCanvas = function (draggingArea, outlineRect) {
  if (Math.ceil(outlineRect.x) - draggingArea.x < 0) {
    return false;
  }
  if (Math.ceil(outlineRect.y) - draggingArea.y < 0) {
    return false;
  }
  if (Math.floor(outlineRect.x + outlineRect.width) - (draggingArea.x + draggingArea.width) > 0) {
    return false;
  }
  if (Math.floor(outlineRect.y + outlineRect.height) - (draggingArea.y + draggingArea.height) > 0) {
    return false;
  }
  if (Math.floor(outlineRect.width) > draggingArea.width || Math.floor(outlineRect.height) > draggingArea.height) {
    return false;
  }
  return true;
};

export const getAnchorPositionAndOffset = (baseImageRect, noRotateRect) => {
  const baseImageCenter = getRectCenter(baseImageRect);
  const offsetX = baseImageCenter.x - noRotateRect.x;
  const offsetY = baseImageCenter.y - noRotateRect.y;
  return { ...baseImageCenter, offsetX, offsetY };
};

export const getBaseImageRectForCrop = (baseImageRect, noRotateRect, degree) => {
  const result1 = getRotateResult(getRectPoints(baseImageRect), -degree, getRectCenter(noRotateRect));
  const result2 = getRotateResult(result1.rotatedRectPoints, degree);
  return result2.outlineRect;
};

export const swapObjects = (obj1, obj2) => {
  let temp = { ...obj1 };
  obj1 = obj2;
  obj2 = temp;
};

export const checkSizeValidation = function (
  elementSize,
  elementSizeRange,
  gripIndex,
  oldRotatedRectPoints,
  newRotatedRectPoints
) {
  if (elementSize.width < elementSizeRange.minWidth || elementSize.height < elementSizeRange.minHeight) {
    return false;
  }
  // else if (elementSize.width > elementSizeRange.maxWidth || elementSize.height > elementSizeRange.maxHeight) {
  //   return false;
  // }

  const result1 = getVectorByGripPosition(gripIndex, oldRotatedRectPoints);
  const result2 = getVectorByGripPosition(gripIndex, newRotatedRectPoints);
  if (result1.p2.x < result1.p1.x) {
    if (result2.p2.x > result2.p1.x) {
      return false;
    }
  } else {
    if (result2.p2.x < result2.p1.x) {
      return false;
    }
  }
  if (result1.p2.y < result1.p1.y) {
    if (result2.p2.y > result2.p1.y) {
      return false;
    }
  } else {
    if (result2.p2.y < result2.p1.y) {
      return false;
    }
  }
  return true;
};

export const getCircleRadius = (scale) => {
  const circleRadiusValue = 10;
  let circleRadius = Math.min(circleRadiusValue, circleRadiusValue / scale);
  if (scale < 0.5) circleRadius = circleRadius * (0.5 / scale);
  if (scale > 2) circleRadius = circleRadius * (2 / scale);
  return circleRadius;
};
